import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import { Page, Document, View, Text, Image, pdf } from "@react-pdf/renderer";
import logotipoLosAndes from "../../assets/LogotipoLosAndes.png";
import logotipoGA from "../../assets/LogotipoGA.png";
import config from "../../config.json";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import { PDFDocument } from "pdf-lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

const s = {
  page: {
    width: "100%",
    padding: "20px 20px 20px 30px",
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  row: {
    flexDirection: "row",
    gap: 4
  },
  col: {
    flexDirection: "column",
    gap: 4
  },
  center: { textAlign: "center" },
  bold: { fontFamily: "Helvetica-Bold" },
  italic: { fontFamily: "Helvetica-Oblique" },
  border: { borderWidth: 1 }
}

//Funcion para convertir un pdf de react-pdf a blob
async function generatePDFBlob(MyDocComponent) {
  const blob = await pdf(<MyDocComponent />).toBlob();
  return blob;
}
//Funcion para descargar pdf de un link y devolver un array de blobs
async function downloadPDFsFromLinks({ links, labelKey }) {
  const blobs = await Promise.all(
    links.map(async (item) => {
      const url = item[labelKey];
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Error al descargar ${item}`);
      return await res.blob();
    })
  );
  return blobs;
}
//Funcion para unir los PDF que estan en un array de blobs
async function mergePDFs(blobs) {
  const mergedPdf = await PDFDocument.create();
  for (const blob of blobs) {
    const arrayBuffer = await blob.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);
    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    copiedPages.forEach(page => mergedPdf.addPage(page));
  }

  const mergedPdfBytes = await mergedPdf.save();
  return new Blob([mergedPdfBytes], { type: 'application/pdf' });
}

export const ExportTransferPDF = (props) => {
  const { procedure } = props;
  const queryParams = "fieldnames=tramiteSenavex&fieldnames=tramiteCertificadoDeInocuidadAlimentariaDeExportaci%C3%B3n&fieldnames=tramiteCertificadoFitosanitarioDeExportaci%C3%B3n&fieldnames=inspeccionSenasag&fieldnames=pagoTaypiSenavex&fieldnames=contravenciones&fieldnames=tramiteAlboYDab-PaseDeSalida&fieldnames=otros&fieldnames=numeroSolicitud"
  const { data, loading } = Request({
    urlApi: `/procedure/${procedure.procedureId || procedure.procedureId}/dataValues?${queryParams}`,
  });
  const [mergedBlob, setMergedBlob] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(true);

  const filteredKeys = data && Object.keys(data).filter(key => key.endsWith("FileStates"))
  const formatedData = filteredKeys && filteredKeys.flatMap(key =>
    data[key].map(item => {
      try {
        return { ...item, ...JSON.parse(item.details), company: data.company.razonSocial };
      } catch (error) {
        console.error("Error al parsear, details:", error, item.details);
      }
    })
  );

  const MyDoc = () => {

    const RenderCustomTable = ({ columns, data }) => {
      let total = 0
      return (
        <>
          {/* Encabezados de columna */}
          <View style={[s.row, { borderBottomWidth: 1, alignItems: "center", fontSize: 8 }]}>
            {columns.map((col, colIndex) => (
              <Text
                key={colIndex}
                style={[s.bold, {
                  width: `${col.width}%`,
                  paddingHorizontal: 5,
                  paddingVertical: 3,
                  textAlign: colIndex >= 1 ? "center" : "left",
                }]}
              >
                {col.label}
              </Text>
            ))}
          </View>

          {/* Filas de datos */}
          {data.map((item, index) => {
            total += item.amount
            return (
              <View
                key={index}
                style={[s.row, { alignItems: "center", fontSize: 7 }]}
              >
                {columns.map((col, colIndex) => (
                  <Text
                    key={colIndex}
                    style={{
                      width: `${col.width}%`,
                      paddingHorizontal: 5,
                      paddingVertical: 3,
                      textAlign: col.name === "amount" ? "right" : "left",
                    }}
                  >
                    {col.name === "item" ? index + 1 : item[col.name]}
                  </Text>
                ))}
              </View>
            )
          })}

          {/* Fila de Total */}
          <View style={[s.row, { borderTopWidth: 1, marginTop: 5, fontSize: 8 }]}>
            {columns.map((col, colIndex) => (
              <Text
                key={colIndex}
                style={[s.bold, {
                  width: `${col.width}%`,
                  paddingHorizontal: 5,
                  paddingVertical: 3,
                  textAlign: col.name === "amount" ? "right" : "left",
                }]}
              >
                {columns[colIndex + 1] && columns[colIndex + 1].name === "amount" && "TOTAL"}
                {col.name === "amount" && total}
              </Text>
            ))}
          </View>
        </>
      );
    };

    return (
      <Document>
        <Page size="A4" style={s.page}>
          <View style={[s.row, { justifyContent: "space-between", alignItems: "center" }]}>
            <Image
              src={config.isLosAndes ? logotipoLosAndes : logotipoGA}
              style={{ width: "200px" }}
            />
            <View style={[s.row, { fontSize: 15 }]}>
              <Text style={s.bold}>Nº</Text>
              <Text>{data.numeroSolicitud ?? 0}</Text>
            </View>
          </View>

          <View style={[s.col, { paddingTop: 20, paddingBottom: 15 }]}>
            <Text style={[s.center, s.bold, { fontSize: 11, paddingBottom: 10 }]}>SOLICITUD DE TRANSFERENCIAS - EXPORTACION</Text>
            <View style={[s.row, { gap: 2 }]}>
              <Text style={{ minWidth: "1.3cm" }}>DE: </Text>
              <Text style={{ width: "50%" }}>{config.isLosAndes ? 'LOS ANDES SRL. - SANTA CRUZ' : 'GAMARRA ANDES SRL. - LA PAZ'}</Text>
              <Text>{" "}</Text>
            </View>
            <View style={[s.row, { gap: 2 }]}>
              <Text style={{ minWidth: "1.3cm" }}>A: </Text>
              <Text style={{ width: "50%" }}>MARIO GAMARRA A. - GERENTE GENERAL .</Text>
              <Text>{" "}</Text>
            </View>
            <View style={[s.row, { gap: 2 }]}>
              <Text style={{ minWidth: "1.3cm" }}>A c.c.: </Text>
              <Text style={{ width: "50%" }}>DEPTO. CONTABILIDAD {config.isLosAndes ? 'SANTA CRUZ' : 'LA PAZ'}</Text>
              <Text>{" "}</Text>
            </View>
            <View style={[s.row, { gap: 2 }]}>
              <Text style={{ minWidth: "1.3cm" }}>FECHA: </Text>
              <Text style={{ width: "50%" }}>{dayjs().locale('es').format('D [de] MMMM [de] YYYY')}</Text>
              <Text style={[s.bold, { fontSize: 10 }]}>RETORNABLE</Text>
            </View>
          </View>
          <View style={[s.border, { fontSize: 8, marginBottom: 15 }]}>
            <RenderCustomTable
              columns={[
                { name: "item", label: "ITEM", width: 4 },
                { name: "company", label: "EMPRESA", width: 15 },
                { name: "det_nroSolPlanilla", label: "NUMERO SOL/PLLA", width: 10 },
                { name: "amount", label: "IMPORTE Bs", width: 10 },
                { name: "det_chequePara", label: "GIRAR CHEQUE PARA:", width: 21 },
                { name: "description", label: "CONCEPTO  DEL PAGO", width: 20 },
                { name: "det_nroCheque", label: "Nº CH", width: 10 },
                { name: "det_banco", label: "EMITENTE", width: 10 },
              ]}
              data={formatedData}
            />
          </View>
          <View>
            <Text>OBSERVACIONES</Text>
          </View>
          <View style={[s.row, s.italic, { opacity: 0.7, justifyContent: "space-evenly", paddingTop: 55 }]}>
            <View style={[s.col, { alignItems: "center", justifyContent: "center" }]}>
              <Text>............................................</Text>
              <Text>Dpto de Contabilidad</Text>
              <Text>{config.isLosAndes ? 'Los Andes SRL SCZ' : 'Gamarra Andes SRL LPZ'}</Text>
            </View>
            <View style={[s.col, { alignItems: "center", justifyContent: "center" }]}>
              <Text>............................................</Text>
              <Text>Gerente General</Text>
              <Text>{config.isLosAndes ? 'Los Andes' : 'Gamarra Andes'} SRL</Text>
            </View>
          </View>
        </Page>
      </Document >
    )
  };

  useEffect(() => {
    setLoadingPDF(true)
    const preparePDF = async () => {
      try {
        if (!data || !formatedData) return;

        const generatedBlob = await generatePDFBlob(MyDoc);
        const downloadedBlobs = await downloadPDFsFromLinks({
          links: formatedData,
          labelKey: 'url',
        });
        downloadedBlobs.unshift(generatedBlob);
        const finalMerged = await mergePDFs(downloadedBlobs);
        setMergedBlob(finalMerged);
      } catch (error) {
        console.error("Error al preparar el PDF:", error);
      } finally {
        setLoadingPDF(false)
      }
    };
    preparePDF();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleDownloadPDFMerged = () => {
    if (!mergedBlob) return;
    const url = URL.createObjectURL(mergedBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `SolicitudTransferencia-${data.numeroSolicitud || 'descarga'}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };

  if (!loading) {
    return <Circle />;
  }

  return (
    <div className="grid place-content-center pb-4 min-w-[300px]">
      <button onClick={handleDownloadPDFMerged} className="flex items-center gap-1 md:gap-2 cursor-poiter group font-semibold text-[#4d74af] hover:text-[#3c5f94] hover:bg-[#618BCC]/20 rounded-md p-2">
        {loadingPDF ? (<><FontAwesomeIcon icon="fas fa-spinner" className="animate-spin text-[30px]" /></>) : (
          <>
            <FontAwesomeIcon icon="fas fa-file-pdf" />Descargar
          </>
        )}
      </button>
    </div>
  );
};